var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef } from 'react';
import { getAuthToken, validateOrRenewUser } from '../Authentication/ApplicationAuthentication';
export function createFormData(data) {
    var fd = new FormData();
    Object.entries(data).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (key === 'file') {
            var file = value;
            fd.append('file', file, file.name);
        }
        else {
            if (typeof value === 'string')
                fd.append(key, value);
            else
                fd.append(key, JSON.stringify(value));
        }
    });
    return fd;
}
function appendCommonHeaders(headers, isPatch) {
    if (isPatch === void 0) { isPatch = false; }
    return __awaiter(this, void 0, void 0, function () {
        var barerToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!headers)
                        headers = new Headers();
                    headers.append('Content-Type', isPatch ? 'application/json-patch+json' : 'application/json');
                    return [4 /*yield*/, getAuthToken()];
                case 1:
                    barerToken = _a.sent();
                    headers.append('Authorization', barerToken);
                    // IE 11 aggressively caches API requests. Using 'no-cache' on all requests
                    // forces IE 11 to behave as-expected at the cost of performance for all
                    // browsers
                    headers.append('Cache-Control', 'no-cache');
                    headers.append('Pragma', 'no-cache');
                    return [2 /*return*/, headers];
            }
        });
    });
}
function logResponse(method, route, response) {
    if (response.status === 422) {
        console.warn("[" + method + "] " + response.status + " " + route);
    }
    else if (response.status >= 400 && response.status !== 422) {
        console.error("[" + method + "] " + response.status + " " + route);
    }
}
function processResponse(response) {
    var contentType = response.headers.get('content-type') || '';
    if (contentType.match(/^application\/json/)) {
        return response.json();
    }
    if (contentType.match(/^(text\/plain|image\/.*|audio\/.*|video\/.*|application\/.*)/)) {
        return response.blob();
    }
    return response.text();
}
var HttpRequestExecutor = /** @class */ (function () {
    function HttpRequestExecutor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    HttpRequestExecutor.prototype.get = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var dataObject, url;
            return __generator(this, function (_a) {
                dataObject = {
                    method: 'GET'
                };
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.getCancellable = function (route, config) {
        return __awaiter(this, void 0, void 0, function () {
            var signal, dataObject, url;
            return __generator(this, function (_a) {
                signal = config.abortAndGetNewSignal();
                dataObject = {
                    method: 'GET',
                    signal: signal
                };
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doCancellableRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.put = function (route, data) {
        return __awaiter(this, void 0, void 0, function () {
            var dataObject, url;
            return __generator(this, function (_a) {
                dataObject = {
                    method: 'PUT'
                };
                if (data) {
                    dataObject.body = JSON.stringify(data || '');
                }
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.putCancellable = function (route, config, data) {
        return __awaiter(this, void 0, void 0, function () {
            var signal, dataObject, url;
            return __generator(this, function (_a) {
                signal = config.abortAndGetNewSignal();
                dataObject = {
                    method: 'PUT',
                    signal: signal
                };
                if (data) {
                    dataObject.body = JSON.stringify(data || '');
                }
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doCancellableRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.patch = function (route, data, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var dataObject, url;
            return __generator(this, function (_a) {
                dataObject = {
                    method: 'PATCH',
                    signal: signal
                };
                if (data) {
                    dataObject.body = JSON.stringify(data || '');
                }
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doRequest(url, route, dataObject, true)];
            });
        });
    };
    HttpRequestExecutor.prototype.post = function (route, data, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var dataObject, url;
            return __generator(this, function (_a) {
                dataObject = {
                    method: 'POST',
                    body: JSON.stringify(data),
                    signal: signal
                };
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.postCancellable = function (route, config, data) {
        return __awaiter(this, void 0, void 0, function () {
            var signal, dataObject, url;
            return __generator(this, function (_a) {
                signal = config.abortAndGetNewSignal();
                dataObject = {
                    method: 'POST',
                    body: JSON.stringify(data),
                    signal: signal
                };
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doCancellableRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.sendFile = function (route, formData, config) {
        return __awaiter(this, void 0, void 0, function () {
            var url, req, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, validateOrRenewUser()];
                    case 1:
                        _d.sent();
                        url = "" + this.baseUrl + route;
                        req = new XMLHttpRequest();
                        req.open('POST', url);
                        _b = (_a = req).setRequestHeader;
                        _c = ['Authorization'];
                        return [4 /*yield*/, getAuthToken()];
                    case 2:
                        _b.apply(_a, _c.concat([_d.sent()]));
                        req.upload.addEventListener('progress', config.progress);
                        // Using addEventListener doesn't properly work, just use these call backs.
                        req.onload = function (event) { return config.load(event, req); };
                        req.onerror = function (event) { return config.error(event, req); };
                        req.send(formData);
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpRequestExecutor.prototype.delete = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var dataObject, url;
            return __generator(this, function (_a) {
                dataObject = {
                    method: 'DELETE'
                };
                url = "" + this.baseUrl + route;
                return [2 /*return*/, this.doRequest(url, route, dataObject)];
            });
        });
    };
    HttpRequestExecutor.prototype.doRequest = function (url, route, dataObject, isPatch) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, validateOrRenewUser()];
                    case 1:
                        _b.sent();
                        _a = dataObject;
                        return [4 /*yield*/, appendCommonHeaders(dataObject.headers, isPatch)];
                    case 2:
                        _a.headers = _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 8, , 12]);
                        return [4 /*yield*/, fetch(url, dataObject)];
                    case 4:
                        response = _b.sent();
                        logResponse(dataObject.method, route, response);
                        if (!(response.status >= 400 && response.status < 600)) return [3 /*break*/, 5];
                        throw response;
                    case 5: return [4 /*yield*/, processResponse(response)];
                    case 6: 
                    // must await the processing here to ensure the exception is handled in the correct context
                    return [2 /*return*/, (_b.sent())];
                    case 7: return [3 /*break*/, 12];
                    case 8:
                        err_1 = _b.sent();
                        if (!(err_1 instanceof Response && err_1.status && err_1.status === 422)) return [3 /*break*/, 10];
                        return [4 /*yield*/, err_1.json()];
                    case 9: throw (_b.sent());
                    case 10: throw err_1;
                    case 11: return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    HttpRequestExecutor.prototype.doCancellableRequest = function (url, route, dataObject, isPatch) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, validateOrRenewUser()];
                    case 1:
                        _b.sent();
                        _a = dataObject;
                        return [4 /*yield*/, appendCommonHeaders(dataObject.headers, isPatch)];
                    case 2:
                        _a.headers = _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 8, , 12]);
                        return [4 /*yield*/, fetch(url, dataObject)];
                    case 4:
                        response = _b.sent();
                        logResponse(dataObject.method, route, response);
                        if (!(response.status >= 400 && response.status < 600)) return [3 /*break*/, 5];
                        throw response;
                    case 5: return [4 /*yield*/, processResponse(response)];
                    case 6: 
                    // must await the processing here to ensure the exception is handled in the correct context
                    return [2 /*return*/, (_b.sent())];
                    case 7: return [3 /*break*/, 12];
                    case 8:
                        err_2 = _b.sent();
                        if (err_2 instanceof Error && err_2.name === 'AbortError') {
                            return [2 /*return*/, new CancelledRequest()];
                        }
                        if (!(err_2 instanceof Response && err_2.status && err_2.status === 422)) return [3 /*break*/, 10];
                        return [4 /*yield*/, err_2.json()];
                    case 9: throw (_b.sent());
                    case 10: throw err_2;
                    case 11: return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    return HttpRequestExecutor;
}());
export { HttpRequestExecutor };
var CancelledRequest = /** @class */ (function () {
    function CancelledRequest() {
    }
    return CancelledRequest;
}());
export { CancelledRequest };
// Used exclusively for class based solutions.
// ie support for AsyncFetch.
var HttpExecutorConfigController = /** @class */ (function () {
    function HttpExecutorConfigController() {
        var _this = this;
        this.controller = null;
        this.abortAndGetNewSignal = function () {
            if (_this.controller) {
                _this.controller.abort();
            }
            var newController = new AbortController();
            _this.controller = newController;
            return newController.signal;
        };
        this.cleanUp = function () {
            if (_this.controller) {
                _this.controller.abort();
            }
        };
    }
    return HttpExecutorConfigController;
}());
export { HttpExecutorConfigController };
// Used in some PoC areas of the application
var MockController = /** @class */ (function () {
    function MockController() {
        this.abortAndGetNewSignal = function () {
            var newController = new AbortController();
            return newController.signal;
        };
        this.cleanUp = function () { return undefined; };
    }
    return MockController;
}());
export { MockController };
export var useHttpConfig = function () {
    var lastAbortController = useRef(null);
    var abortAndGetNewSignal = function () {
        if (lastAbortController.current) {
            lastAbortController.current.abort();
        }
        var newController = new AbortController();
        lastAbortController.current = newController;
        return newController.signal;
    };
    var cleanUp = function () {
        if (lastAbortController.current) {
            lastAbortController.current.abort();
        }
    };
    // Ensure any requests currently controlled by this are aborted
    // when the hook unmounts
    useEffect(function () {
        return function () {
            cleanUp();
        };
    }, []);
    return {
        abortAndGetNewSignal: abortAndGetNewSignal,
        cleanUp: cleanUp
    };
};
export function isHttpResponse(item) {
    return item.status !== undefined;
}
export function isHttpAuthenticationError(item) {
    if (isHttpResponse(item)) {
        if (item.status === 401 || item.status === 403)
            return true;
    }
    return false;
}
export var getExecutor = function (url) {
    return new HttpRequestExecutor(url);
};
